<template>
  <transition name="slide">
    <div
      v-if="show"
      class="bim-toast"
      @mouseenter="timeoutReset"
      @mouseleave="timeoutRun"
      :class="toastClass"
    >
      <!-- Кастомный компонент в тосте -->
      <component v-if="typeof text === 'object'" :is="text" />
      <div class="bim-toast__content" v-else>
        <bim-text-main bold class="bim-toast__title">{{ title }}</bim-text-main>
        <p class="bim-toast__text" v-html="text"></p>
      </div>

      <!-- Кнопка закрытия тоста -->
      <button @click="show = false" class="bim-toast__button" v-html="require('@/assets/img/icon-close.svg')"></button>
    </div>
  </transition>
</template>

<script>
import bimTextMain from '@/components/text/bimTextMain/bimTextMain'
export default {
  name: 'bimToast',
  components: {
    bimTextMain,
  },
  props: {
    title: {
      type: String,
      default: 'Отлично!',
    },
    /**
     * Object для рендера своих компонентов
     * String - обычный текст
     */
    text: {
      type: [String, Object],
      required: true,
    },
    duration: {
      type: Number,
      default: 5000,
    },
    /**
     * Вызывается при закрытии/истечении времени тоста
     */
    onClose: {
      type: Function,
      default: () => {}
    },
    /**
     * Кастомный класс для тоста
     */
    toastClass: {
      type: String
    }
  },
  data () {
    return {
      show: true,
      timeout: null,
    }
  },
  mounted () {
    if (this.duration !== 0) {
      this.timeoutRun()
    }
  },
  watch: {
    show (val) {
      if (!val) {
        this.onClose()
        setTimeout(() => {
          if (
            this.$el.parentNode &&
            this.$el.parentNode.childElementCount === 0
          ) {
            this.$el.parentNode.remove()
          }
        }, 500)
      }
    }
  },
  methods: {
    timeoutReset () {
      if (this.duration !== 0) {
        clearTimeout(this.timeout)
      }
    },
    timeoutRun () {
      if (this.duration !== 0) {
        this.timeout = setTimeout(() => {
          this.show = false
        }, this.duration)
      }
    },
  },
}
</script>

<style lang="scss">
.bim-toast-wrapper {
  position: absolute;
  bottom: 0;
  right: 0;
  transition: 0.2s;
  overflow: visible;
  margin: 0;
  pointer-events: none;
  z-index: 1111;
  width: fit-content;
  height: fit-content;
  background: transparent;
  backdrop-filter: blur(3px);
}

.bim-toast {
  position: relative;
  width: 325px;
  min-height: 148px;
  background-color: $white-color;
  color: $black-color;
  border-radius: 10px;
  box-shadow: 0 20px 60px 0 rgba(0, 0, 0, 0.1);
  transition: 0.2s;
  pointer-events: all;
  animation: slideIn 0.3s;
  z-index: 1112;
  opacity: .85;

  .bim-toast__content {
    padding: 24px;
  }

  &:not(:last-child) {
    margin-bottom: 14px;
  }
  &__title {
    margin-bottom: 8px;
  }
  &__text {
    @include text-style(14px, normal, 1.57, 0.2px);
  }
  &__button {
    position: absolute;
    top: 0;
    right: 0;
    padding: 14px;
    opacity: 0.5;
    border: none;
    background: none;
    cursor: pointer;

    ::v-deep svg {
      width: 15px;
      height: 15px;
    }

    &:hover {
      opacity: 0.75;
    }
  }

  .bim-toast__text,
  .bim-toast__title {
    word-break: break-word;
  }

  &.success {
    .bim-toast__title {
      color: $primary-color;
    }
  }

  &.error {
    .bim-toast__title {
      color: $red-color-400;
      font-size: 10px;
      text-transform: uppercase;
      line-height: 2;
      letter-spacing: 1px;
    }
  }
}

.slide-enter-active {
  animation: slideIn 0.3s;
}
.slide-leave-active {
  animation: slideOut 0.3s;
}

@keyframes slideIn {
  0% {
    transform: translateX(370px);
  }
  70% {
    transform: translateX(-40px);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes slideOut {
  0% {
    transform: translateX(0);
  }
  30% {
    transform: translateX(-40px);
  }
  100% {
    transform: translateX(370px);
  }
}
</style>
